export type ChipWeights = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

export enum ChipSelectionOrigin {
  User = 'User',
  System = 'System',
  PlayerConfig = 'PlayerConfig',
}

export enum ChipTypes {
  CasinoChip = 'CasinoChip',
  FreeChip = 'FB',
}

export interface BaseChipValueType {
  color?: string;
  value: number;
  weight: number;
  disabled?: boolean;
  selectedBy?: ChipSelectionOrigin;
  disabledReason?: string;
}

export interface CasinoChipValueType extends BaseChipValueType {
  type: ChipTypes.CasinoChip;
}

export interface FreeChipValueType extends BaseChipValueType {
  type: ChipTypes.FreeChip;
  count: number;
  maxLimit: number;
}

export type ChipValueType = CasinoChipValueType | FreeChipValueType;

export type ChipsDataType = {
  casinoChips: CasinoChipValueType[];
  freeChips: FreeChipValueType[];
};
